import styled from "styled-components";

export const Container = styled.div`
  color: #fff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: 1rem;
`;

export const InfoDiv = styled.div`
  display: flex;
  gap: 20px;
  @media (max-width: 475px) {
    gap: 16px;
    width: 100%;
    max-width: 95%;
    margin: 0 auto;
    justify-content: space-between;
  }
`;

export const Info = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const Text = styled.p`
  font-size: 0.75rem;
`;

export const DropDownSelect = styled.select`
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  border: none;
  color: white;
  font-size: 0.75rem;
  width: 100%;
  height: 100%;
  cursor: pointer;
  &:focus-visible {
    border: none;
  }
`;

export const StyledOption = styled.option``;

export const DropDown = styled.label`
  position: relative;
  width: ${props => `${props.width}px`};
  display: flex;
  align-items: center;

  &::after {
    content: url("/svgs/arrow_down.svg");
    position: absolute;
    right: 0;
    top: 0.2px;
    cursor: pointer;
    pointer-events: none;
  }
`;
